import { deleteRequest, getRequest, postRequest, putRequest } from "../../apiClient";
import { DashboardEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetDashboard = async (queryString: any) => {
    var _url = DashboardEndpoint.DASHBOARD_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetDashboardNotices = async () => {
    var _url = DashboardEndpoint.DASHBOARD_NOTICES_URL;
    var res = await getRequest(_url);

    return res;
};
//#endregion